import { render, staticRenderFns } from "./dashBoardDev.vue?vue&type=template&id=67c2450e&scoped=true"
import script from "./dashBoardDev.vue?vue&type=script&lang=js"
export * from "./dashBoardDev.vue?vue&type=script&lang=js"
import style0 from "./dashBoardDev.vue?vue&type=style&index=0&id=67c2450e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c2450e",
  null
  
)

export default component.exports